import { useSelector } from 'react-redux';

// Mirrors the server rule: recording payments, refunds, voids, credit notes
// and receipts is for finance managers and admins only.
export function useCanManageFinance() {
  const { isAdmin, user } = useSelector((s) => s.auth || {});
  return !!(isAdmin || user?.role === 'manager');
}
